import { createApp } from 'vue';
import RelatedContentContainerBlock from './RelatedContentContainerBlock.vue';

function mountRelatedContentContainerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="related-content-container-block"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'RelatedContentContainerBlockApp',
		});

		app.component('related-content-container-block', RelatedContentContainerBlock);
		app.mount(block);
	})
}

mountRelatedContentContainerBlocks();
